<template>
    <div>
        <div class="text-16px color-#fff font-900 text-center pb-20px">
            Chat Style
        </div>
        <div class="max-h-400px overflow-y-auto">
            <!-- 使用 currentStyleList 计算属性 -->
            <div class="w-100% mb-10px model-box relative" v-for="(item, index) in currentStyleList"
                :key="item.id || index" @click="handleSelect(item)" :class="[item.isSelected ? 'active' : '']">
                <div class="flex justify-between">
                    <div class="text-14px color-#fff flex-shrink-0 font-500 flex max-w-200px items-center">
                        <!-- 模型图标 -->
                        <div v-if="item.id === 3" class="w-11px w-13px flex items-center justify-center mr-4px mb-1px">
                            <img src="@/assets/images/message/vip_model.svg" alt="" class="w-full h-full">
                        </div>

                        <!-- VIP 图标 -->
                        <div v-if="item.isVipSee || item.isCostSee"
                            class="w-11px w-13px flex items-center justify-center mr-4px mb-1px">
                            <img src="@/assets/images/message/vip_icon.svg" alt="" class="w-full h-full">
                        </div>

                        <div class="relative">
                            {{ item.title }}
                            <!-- Ultra 标签 -->
                            <!-- <div class="ultra" v-if="index != 0">
                                Ultra
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="text-10px py-6px model-text">
                    {{ item.title_desc }}
                </div>

                <!-- 选中图标 -->
                <div v-if="item.isSelected" class="w-16px h-16px flex item-centers absolute bottom--1px right--1px">
                    <img src="@/assets/images/message/gouyxuan.svg" alt="" class="w-full h-full">
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { computed, watch, onMounted } from 'vue'
import { showSuccessToast, showLoadingToast } from '@/utils/toast'
import { MessageAPI } from '@/services/message'
import { logEventSafe } from '@/plugins/firebase'

const props = defineProps<{
    close: () => void
    modelList: any[]
}>()

// 获取当前选中的模型
const styleList = computed<any[]>(() =>
    (props.modelList || []).filter((item: any) => item.isChecked)
)

// 获取当前模型的样式列表
const currentStyleList = computed(() => {
    const list = styleList.value[0]?.more?.LiteraryStyle || []
    // 确保返回的是响应式数组
    return [...list]
})

// 监听 currentStyleList 变化，设置默认选中
watch(currentStyleList, (newList) => {
    if (newList.length > 0) {
        // 检查是否已经有选中的项
        const hasSelected = newList.some(item => item.isSelected)

        // 如果没有选中的项，默认选中第一个
        if (!hasSelected) {
            // 使用 setTimeout 确保在下一次 DOM 更新时设置
            setTimeout(() => {
                newList[0].isSelected = true
            }, 0)
        }
    }
}, { immediate: true })

// 或者使用 onMounted
onMounted(() => {
    // 组件挂载时检查默认选中
    const list = currentStyleList.value
    if (list.length > 0) {
        const hasSelected = list.some(item => item.isSelected)
        if (!hasSelected) {
            list[0].isSelected = true
        }
    }
})

/**
 * 处理样式选择
 */
const handleSelect = async (selectedItem: any) => {
    // 文风功能选择埋点
    logEventSafe('chatstyle_select_click')
    // 如果已经选中，直接返回
    if (selectedItem.isSelected) {
        return
    }

    // VIP 权限检查
    // if (![5].includes(infoData.value.role)) {
    //     router.push({
    //         name: 'Vip',
    //         query: { type: 'u', tab: 'chat', isStyle: 'true' }
    //     })
    //     // 文风切换限制，ultra订阅曝光
    //     logEventSafe('chatstyle_switch_ultra_popup_show')
    //     return
    // }

    try {
        showLoadingToast()

        // 获取当前模型
        const currentModel = styleList.value[0]
        if (!currentModel) {
            console.error('No model selected')
            return
        }

        // 调用 API 更新配置
        await MessageAPI.setUserModelConfig({
            chatModelId: currentModel.id,
            group: selectedItem.group,
            groupIndex: selectedItem.group_index
        })
        // 文风切换成功埋点
        logEventSafe('chatstyle_click_switch_success')
        // 更新选中状态
        updateSelection(selectedItem)

        showSuccessToast('Successful switch', { duration: 1000 })
        props.close()
    } catch (error) {
        // 文风切换失败埋点
        logEventSafe('chatstyle_click_switch_failed')
        console.error('Failed to switch style:', error)
    }
}

/**
 * 更新选中状态
 */
const updateSelection = (selectedItem: any) => {
    // 先将所有项设置为未选中
    currentStyleList.value.forEach((item: any) => {
        item.isSelected = false
    })

    // 设置当前项为选中
    selectedItem.isSelected = true
}
</script>
<style scoped lang="scss">
.model-box-box {
    height: 500px;
    overflow-y: scroll;
    background: #01031B;
}

.model-box {
    // margin-left: 10px;
    // background-color: linear-gradient(90deg, #353750 0%, #323C4E 100%);
    // background: linear-gradient(90deg, #353750 0%, #323C4E 100%);
    background: rgba(255, 255, 255, 0.15);

    border-radius: 10px;
    padding: 10px;
    border: 1px solid transparent;

    &.active {
        border: 1px solid #7284F7;
        background: rgba(114, 132, 247, 0.1);
    }

    &.ishot {
        border: 1px solid #EE0772;
        background: rgba(244, 147, 253, 0.1) !important;

    }

    &.isCostSee {
        background: linear-gradient(90deg, #353750 0%, #323C4E 100%);
    }

    .ultra {
        position: absolute;
        top: -3px;
        right: -35px;
        background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
        border-radius: 10px 10px 10px 0px;
        font-weight: 800;
        padding: 0 5px;
        font-size: 9px;
        color: #27053E;
    }
}

.cost {
    background: rgba(171, 182, 255, 0.1);
}

.thinking {
    background: rgba(53, 55, 80, 1);
    border-radius: 12px;
    padding: 2px 5px;
}

.model-text {}
</style>